import gql from 'graphql-tag';

export const ListJobsByDate = gql`
	query ListJobsByDate(
		$filter: TableJobFilterInput
		$limit: Int
		$nextToken: String
	) {
		listJobsByDate(filter: $filter, limit: $limit, nextToken: $nextToken) {
			items {
				id
				companyId
				company {
					id
					name
				}
				departmentId
				department {
					id
					name
				}
				referrals {
					id
					contactId
					contact {
						id
						emailAddress
						userId
					}
					status
				}
				title
				referralBonus
				description
				publicLink
				location
				shares
				views
				status
				dateCreated
				externalJobId
				externalDepartmentId
				externalSource
			}
			nextToken
		}
	}
`;
